import React, {useEffect} from "react";
import SosCards from "./components/sos-cards.jsx";
import {
  exportCards,
  exportData,
  reportsInfo
} from "../../utils/utils.js";
import ReportChart from "../../../../../components/reports/charts/report-chart.jsx";
import ReportHeatmapTable from "../../../../../components/reports/report-heatmap-table/report-heatmap-table.jsx";
import {
  createBarChart,
  createHorizontalBarChart,
  exportHeatMap
} from "../../../../../components/reports/charts/utils.js";
import TableLegend from "../../../traffic-flow-point/components/content/table-legend.jsx";
const ReportContent = ({data, collapsed, analysis}) => {
  const hasWeekdayData = (items) => Array.isArray(items) && items.some((item) =>
    ['domingo', 'segunda', 'terca', 'quarta', 'quinta', 'sexta', 'sabado'].some((day) => Number(item?.[day]) > 0),
  );

  useEffect(() => {
    if(!data) return;

    if (analysis === 'register') {
      createHorizontalBarChart({
        data: data?.getRegistrationInfo?.status,
        reportInfo: reportsInfo.sosRegistrationChart,
        labelKey: "status",
        reportName: "Cadastro de Cidadãos/Empresas",
        exportName: "Cadastro Cidadãos e Empresas"
      })

      createHorizontalBarChart({
        data: data?.getRegistrationInfo?.citizen_history,
        reportInfo: reportsInfo.inactivationRegistrationReason,
        labelKey: "status",
        reportName: "Motivo da inativação dos cadastros",
        exportName: "Motivo da inativação"
      });

      createHorizontalBarChart({
        data: data?.getRegistrationInfo?.life_risk,
        reportInfo: reportsInfo.lifeRisk,
        labelKey: "status",
        reportName: "Grau de risco das medidas protetivas",
        exportName: "Grau de risco"
      });

      createBarChart({
        data: data?.getProtectionTypes,
        reportInfo: reportsInfo.registrationByProtectionType,
        labelFieldName: "program_name",
        limit: 6,
        rotated: true,
        reportName: "Cadastros por programa de proteção",
        exportName: "Cadastro por proteção"
      });

      createBarChart({
        data: data?.getViolenceTypes,
        reportInfo: reportsInfo.registrationByViolenceType,
        labelFieldName: "violence_type",
        rotated: true,
        reportName: "Cadastros por tipo de violência",
        exportName: "Cadastro por violência"
      });

      createBarChart({
        data: (data?.getFamilyConnections ?? []).map(el => ({qty: el.qty, aggressor_bond: el.aggressor_bond.toLowerCase()})),
        reportInfo: reportsInfo.familyRelationship,
        labelFieldName: "aggressor_bond",
        limit: 10,
        reportName: "Vínculo do agressor com o protegido",
        exportName: "Vínculo do agressor"
      });

      createBarChart({
        data: data?.getCitizensYearsOld,
        reportInfo: reportsInfo.citizensByAge,
        labelFieldName: "age_range",
        reportName: "Cadastro de protegidos por faixa etária",
        exportName: "Cadastros por faixa etária"
      });

      createBarChart({
        data: data?.getProtectedPlacesLocations,
        reportInfo: reportsInfo.citizensByNeighborhood,
        labelFieldName: "neighborhood",
        limit: 10,
        reportName: "Cadastro de protegidos por bairros",
        exportName: "Cadastros por bairros"
      });

      return;
    }

    if (analysis === 'event') {
        if (Array.isArray(data?.getSosDetails) && data.getSosDetails.length > 0) exportData(data.getSosDetails, data?.boName);
        if (data?.sosCards) exportCards(data.sosCards, data?.boName);
        if (hasWeekdayData(data?.getAttendancesByWeekday)) exportHeatMap(data.getAttendancesByWeekday, "Acionamento por dia da semana");

        createBarChart({
          data: data?.getProtectionByEvents,
          reportInfo: reportsInfo.protectionByEvents,
          labelFieldName: "protection",
          limit: 10,
          reportName: "Acionamento por tipo de proteção",
          exportName: "Acionamento por proteção"
        });

        createBarChart({
          data: data?.getEventProvidences,
          reportInfo: reportsInfo.providenceByEvent,
          labelFieldName: "providence",
          limit: 10,
          reportName: "Providência após acionamento"
        });
    }
  }, [analysis, data, collapsed]);

  return(
    <>
      { analysis === 'register' && (
        <>
          <ReportChart key={`registration-${collapsed}`} reportInfo={reportsInfo.sosRegistrationChart} type="horizontal" divisor={false} hasTotal={true} totalQty={data?.getRegistrationInfo?.status?.reduce((acc, el) => acc + el.qty, 0) ?? ""}/>
          <ReportChart key={`inactivation-reason-${collapsed}`} reportInfo={reportsInfo.inactivationRegistrationReason} type="horizontal" divisor={false} wrapperClassName="mt-3"/>
          <ReportChart key={`life-risk-${collapsed}`} reportInfo={reportsInfo.lifeRisk} type="horizontal" wrapperClassName="mt-3"/>

          <>
            <div className="flex text-center!">
              <div className="flex-1">
                <ReportChart key={`registration-protection-${collapsed}`} reportInfo={reportsInfo.registrationByProtectionType} divisor={false} limit={6} dataLength={data?.getProtectionTypes?.length ?? 0}/>
              </div>

              <div className="flex-1">
                <ReportChart key={`registration-violence-${collapsed}`} reportInfo={reportsInfo.registrationByViolenceType} divisor={false}/>
              </div>

            </div>

            <div className="chart-divisor"/>
          </>

          <ReportChart key={`aggressor-relation-${collapsed}`} reportInfo={reportsInfo.familyRelationship} limit={10} dataLength={data?.getFamilyConnections?.length ?? 0}/>
          <ReportChart key={`age-protection-${collapsed}`} reportInfo={reportsInfo.citizensByAge}/>
          <ReportChart key={`neighborhood-protection-${collapsed}`} reportInfo={reportsInfo.citizensByNeighborhood} limit={10} dataLength={data?.getProtectedPlacesLocations?.length ?? 0} divisor={false}/>
          <TableLegend data={"* Os totais podem apresentar divergência devido aos cadastros com múltiplos programas de proteção e agressores."}/>
        </>
      )}

      { analysis === 'event' && (
          <>
            <section className="print:break-inside-avoid!">

              <SosCards key={`cards-${collapsed}`} data={data?.sosCards} boName={data?.boName}/>

              <ReportHeatmapTable
                  key={`heatmap-${collapsed}`}
                  data={data?.getAttendancesByWeekday ?? []}
                  title={reportsInfo.eventsByWeekDay.reportName}
                  tableId={reportsInfo.eventsByWeekDay.reportId}
                  sheetName="Acionamento por dia da semana"
                  rowLabelKey="hour"
                  rowPeriodKey="t"
                  minKey="min"
                  maxKey="max"
                  showExportableTable={false}
                  className={'print:break-inside-auto! print:break-before-auto! print:mt-[15px]!'}
                  divisorClassName={'print:hidden!'}
              />
            </section>

            <ReportChart key={`activation-protection-${collapsed}`} reportInfo={reportsInfo.protectionByEvents} limit={10} dataLength={data?.getProtectionByEvents?.length ?? 0}/>
            <ReportChart key={`activation-providence-${collapsed}`} reportInfo={reportsInfo.providenceByEvent} limit={10} dataLength={data?.getEventProvidences?.length ?? 0} divisor={false}/>
          </>
      )}

      <div id="chart-tables"/>
    </>
  )
}

export default ReportContent;